import { Controller } from "@hotwired/stimulus";

// Connects to data-controller='flash-message'
export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.element.remove();
    }, 8000); // Remove flash message after 8 seconds
  }

  close() {
    this.element.remove();
  }
}
